module.exports = __webpack_public_path__ + "img/kettle.1f74448.png";